import type React from 'react';

interface LobbyMessageBannerProps {
  message: string | null | undefined;
}

export const LobbyMessageBanner: React.FC<LobbyMessageBannerProps> = ({ message }) => {
  if (!message) {
    return null;
  }

  return (
    <output className="lobby-message-banner" aria-live="polite">
      <p className="lobby-message-banner__text">{message}</p>
    </output>
  );
};
